import React, { useState, useEffect } from "react";

interface PriceInputProps {
  price: number;
  setPrice: (newPrice: number) => void;
  style?: React.CSSProperties;
  editable?: boolean;
  fitContent?: boolean;
}

const PriceInput: React.FC<PriceInputProps> = ({
  price,
  setPrice,
  style,
  editable = true,
  fitContent = false,
}) => {
  const [priceStr, setPriceStr] = useState("");

  // when price changes, update priceStr
  useEffect(() => {
    setPriceStr(price.toFixed(2));
  }, [price]);

  // when typing in input, update priceStr (ignore non numbers or dots)
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value.replace(/[^0-9.]/g, "");
    setPriceStr(val);
  };

  // when onBlur input, if priceStr is valid number, update price
  // otherwise, revert priceStr to price
  const handleBlur = () => {
    const num = parseFloat(priceStr);
    if (isNaN(num)) setPriceStr(price.toFixed(2));
    else setPrice(num);
  };

  // size to content so the whole number always shows and never scrolls inside
  const fitStyle: React.CSSProperties = fitContent
    ? { width: `${priceStr.length + 2}ch`, flexShrink: 0 }
    : {};

  return editable ? (
    <input
      type="text"
      value={"$" + priceStr}
      onChange={handleChange}
      onFocus={(e) => {
        const target = e.target;
        setTimeout(() => target.select(), 0);
      }}
      onContextMenu={(e) => e.preventDefault()}
      onBlur={handleBlur}
      style={{ ...style, ...fitStyle, textAlign: "right" }}
    />
  ) : (
    <span>${priceStr}</span>
  );
};

export default PriceInput;
